<template>
  <el-dialog
    :visible="show"
    @update:visible="updateVisiable($event)"
    :title="lang.download"
    width="410px"
    :show-close="true"
    :top="top"
    class="down_dialog"
  >
    <div class="dialog_content">
      <div class="hint_message">
        <div>{{lang.hold}}</div>
        <div style="margin-top: 5px">{{lang.leaveDown}}</div>
      </div>
      <div class="text_down">{{lang.hitDown}}</div>
      <div class="dialog_btn">
        <el-button
          @click="handleDownload"
          style="width: 120px;height: 100%;background: #0f408a;border: none;color: #FFFFFF"
        >{{lang.download}}</el-button>
        <el-button
          @click="handleCancel"
          style="width: 120px;height: 100%;background:#cccccc;border: none;color: #FFFFFF"
        >{{lang.cancel}}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { language } from "../../language/get";

export default {
  data() {
    return { lang: language() };
  },
  mounted(){
    
  },
  props: {
    top: {
      type: String,
      default: "30vh"
    },
    show: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    updateVisiable(v) {
      this.$emit("update:show", v);
    },
    handleCancel() {
      this.$emit("update:show", false);
    },
    handleDownload() {
      window.open(
        "https://www.google.cn/intl/zh-CN/chrome/?brand=CHBD&gclid=EAIaIQobChMI_JKx1J2Z6QIVjqmWCh2-qwpkEAAYASAAEgKlBvD_BwE&gclsrc=aw.ds"
      );
    }
  }
};
</script>

<style scoped>
.down_dialog .dialog_content {
  box-sizing: border-box;
}

.dialog_btn {
  height: 40px;
  margin: auto;
  margin-top: 30px;
  display: flex;
  justify-content: space-around;
}

.hint_message {
  color: #424242;
  font-size: 18px;
  text-align: center;
  margin-top: 20px;
}
.text_down {
  color: #a1a1a1;
  font-size: 14px;
  text-align: center;
  margin-top: 20px;
}
</style>

<style>
.down_dialog .el-dialog__title {
  font-size:14px !important;
}
.down_dialog .el-dialog__body {
  padding: 0 20px 12px 20px !important;
}
.down_dialog .el-dialog {
  padding: 9px 20px 18px 20px;
  border-radius: 5px;
}
.down_dialog .el-dialog .el-dialog__header {
  padding: 0 !important;
  border-bottom: 1px solid #aaaaaa !important;
  height: 36px !important;
  line-height: 36px !important;
}
.down_dialog .el-dialog__headerbtn {
  top: 10px;
}
</style>